export default __webpack_public_path__ + "static/media/A4 large 10.f793e665.jpg";